module.exports = __webpack_public_path__ + "img/icon-spmenu-list-harvest.eb38cd42.png";